import { render } from "./ViewNotificacao.vue?vue&type=template&id=0a0d7926"
import script from "./ViewNotificacao.vue?vue&type=script&lang=js"
export * from "./ViewNotificacao.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__